import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

export function ViewInAppNotificationsMenuItem(props: { closeMenu: () => void; openDialog: () => void }) {
  const { closeMenu, openDialog } = props;

  return (
    <MenuItem
      onClick={() => {
        closeMenu();
        openDialog();
      }}
    >
      <ListItemIcon>
        <NotificationsOutlinedIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>In-App-Benachrichtigungen</ListItemText>
    </MenuItem>
  );
}
